import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getVacancyPage } from "@/_pages/vacancy/api";
import type { VacancyListType, VacancyPageType } from "@/_pages/vacancy/model";
import { VacancyPage } from "@/_pages/vacancy/ui";

type PageProps = {
  cms: {
    pageData: VacancyPageType;
    vacancyList: VacancyListType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { vacancyList, pageData },
  } = props;

  return <VacancyPage vacancyList={vacancyList} pageData={pageData} />;
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getVacancyPage()),
      };
    },
    { res },
  );
}

export default Page;
